import { useServerStatus } from '@/contexts/server-status-context'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { useI18n } from '@/i18n'

export function ServerUnavailableOverlay() {
  const i18n = useI18n()
  const { isServerAvailable, isChecking } = useServerStatus()

  if (isServerAvailable) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm" data-testid="server-unavailable-overlay">
      <div className="flex flex-col items-center gap-4 text-center p-8 max-w-md">
        <div className="rounded-full bg-status-warning-subtle p-4 dark:bg-status-warning-subtle/30">
          <AlertTriangle className="h-12 w-12 text-status-warning dark:text-status-warning-muted" />
        </div>

        <h2 className="text-2xl font-semibold tracking-tight" data-testid="server-unavailable-heading">
          {i18n.serverStatus.serverUnavailable}
        </h2>

        <p className="text-muted-foreground">
          {i18n.serverStatus.serverUnavailableMessage}
        </p>

        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <RefreshCw className={`h-4 w-4 ${isChecking ? 'animate-spin' : ''}`} />
          <span>
            {isChecking ? i18n.serverStatus.checkingConnection : i18n.serverStatus.waitingForServer}
          </span>
        </div>

        <p className="text-xs text-muted-foreground mt-4">
          {i18n.serverStatus.autoReconnect}
        </p>
      </div>
    </div>
  )
}
